import { Link } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { formatNumber } from "@msuite/utils/numbers";
import type { VendorArticeListItem } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<VendorArticeListItem>();

export const columns = [
	columnHelper.accessor("identifier", {
		id: "identifier",
		header: localized("general.identifier"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("contactName", {
		id: "contactName",
		header: localized("stock.vendor"),
		cell: (cell) => (
			<Link href={`/contacts/${cell.row.original.contactId}`}>{cell.getValue()}</Link>
		),
	}),
	columnHelper.accessor("purchasePrice", {
		id: "purchasePrice",
		header: localized("stock.purchase_price"),
		cell: (cell) => formatNumber(cell.getValue(), "currency"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	createRowActions(RowActions),
];
